import React, { useState, useEffect } from 'react';
import { translate } from 'react-multi-lang';
import { SyncOutlined, LeftOutlined, AlertFilled, CloseOutlined, PauseOutlined, MinusOutlined, CopyOutlined } from '@ant-design/icons';

import {Form, Row, Col, Button, Input, InputNumber, DatePicker, Select, Divider, Switch, Space, Tooltip, message } from 'antd';

import { AllHtmlEntities } from 'html-entities';
import { Api, HtmlStrings } from '../../../helpers';

const entities = new AllHtmlEntities();

function Empresa(props){



  const [id, setId] = useState(props.item.id);
  const [nom, setNom] = useState(entities.decode(props.item.nom));
  const [descripcio, setDescripcio] = useState(eval("props.item.descripcio_"+props.t('idioma')));
  const [oferta, setOferta] = useState(eval("props.item.oferta_"+props.t('idioma')));
  const [telefon, setTelefon] = useState(props.item.telefon);
  const [email, setEmail] = useState(props.item.email);
  const [web, setWeb] = useState(() => {
    const url = HtmlStrings.urlAddHttps(props.item.web);
    return url;
  });
  const [persona_contacte, setPersona_contacte] = useState(entities.decode(props.item.persona_contacte));
  const [adress, setAdress] = useState(entities.decode(props.item.adress));
  const [cp, setCp] = useState(props.item.cp);
  const [ciutat, setCiutat] = useState(entities.decode(props.item.ciutat));
  const [logo, setLogo] = useState(props.item.logo);

  useEffect(() => {
    setId(props.item.id);
    setNom(entities.decode(props.item.nom));
    //setDescripcio(<p>{entities.decode(eval("props.item.descripcio_"+props.t('idioma'))).replace(/[\n\r]/gm,'<br>').replace(/<br><br>/gm,'<br>')}</p>);
    setDescripcio(posar_br(eval("props.item.descripcio_"+props.t('idioma')),props.t('botiga.descripcio')));
    setOferta(posar_br(eval("props.item.oferta_"+props.t('idioma')),props.t('empreses.oferta')));
    setTelefon(props.item.telefon);
    setEmail(props.item.email);
    //setWeb(props.item.web);
    setWeb(HtmlStrings.urlAddHttps(props.item.web));
    setPersona_contacte(entities.decode(props.item.persona_contacte));
    setAdress(entities.decode(props.item.adress));
    setCp(props.item.cp);
    setCiutat(entities.decode(props.item.ciutat));
    setLogo(props.item.logo);
  },[props.item, props.t('idioma')]);



  const posar_br = (text, titol) =>{
    if(!text) return '';
    const txt = entities.decode(text).replace(/[\n\r]/gm,'<br>').replace(/<br><br>/gm,'<br>')
    const a = txt.split("<br>")
    const result = a.map((item)=>{
      //return(<p>{item}</p>)
      return(<>{item}<br/></>)
    })

    return <><h2>{titol}</h2><p>{result}</p></>;
  }

  if(!nom){
      return <SyncOutlined spin title="Loading..." style={{fontSize: '3rem'}} />;
    } else {
      //console.log('oferta',oferta)
      return(
        <>
        <Row>
          <Col span="24">
            {!logo ? null : <img className="img-responsive" alt={nom} src={logo} style={{maxHeight: '200px', width: 'auto', maxWidth: '400px', height: 'auto'}}/>}
            <p>{descripcio}</p>
            <p>{oferta}</p>
            <h2>{props.t('generic.dades_contacte')}</h2>
            {!persona_contacte ? null : <p>Persona de contacte: <b>{persona_contacte}</b></p>}
            {!telefon ? null : <p>{props.t('contacto.telefono')}: <b><a href={`tel:${telefon}`}>{telefon}</a></b></p>}
            {!email ? null : <p>{props.t('contacto.email')}: <b><a href={`mailto:${email}`}>{email}</a></b></p>}
            {!web ? null : <p>Web: <b><a href={web} target='_blank'>{web}</a></b></p>}
            {!adress ? null : <p>{props.t('contacto.direccion')}: <b>{adress}</b></p>}
            {!cp ? null : <p>{props.t('contacto.cp')}: <b>{cp}</b></p>}
            {!ciutat ? null : <p>{props.t('contacto.ciudad')}: <b>{ciutat}</b></p>}
            <br/>
          </Col>
        </Row>
            <Row type="flex" justify="start" style={{marginTop: 25, marginBottom: 25}}>
              <Col>
                <Button onClick={props.callback}>{props.t('generic.back')}</Button>
              </Col>
            </Row>
        </>
      );
    }
}
export default translate(Empresa);
